import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Step } from './step';
import { VIEW_LAYOUT } from './consts';
import { StepsContext } from './steps-context';

function isStep(child) {
  if (child != null) {
    return Object.prototype.isPrototypeOf.call(Step, child.type) || Step === child.type;
  }
  return false;
}

export class StepGroupView extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]).isRequired,
    relativePath: PropTypes.string.isRequired,
    parentPath: PropTypes.string.isRequired,
    fullPath: PropTypes.string.isRequired,
    layout: PropTypes.oneOf(_.values(VIEW_LAYOUT)).isRequired,
  };

  getPath = (child, parentPath) =>
    child &&
    child.props &&
    (_.isFunction(child.props.path) ?
      child.props.path(parentPath) :
      child.props.path
    );

  findCurrentStep = (children, parentPath, path) => _.findIndex(
    children,
    child => this.getPath(child, parentPath) === path
  );

  renderStepContent = (activeStep) => {
    if (!activeStep) return (null);
    return (
      <div className="step-content">
        <StepsContext.Provider value={{
          parentPath: this.props.relativePath,
          fullPath: this.props.fullPath,
          layout: this.props.layout,
        }}
        >
          {activeStep.props.children}
        </StepsContext.Provider>
      </div>
    );
  }

  render() {
    const children = React.Children.toArray(this.props.children);
    // Get the path for this level based on the parent
    const currentStepIndex = this.findCurrentStep(
      children,
      this.props.parentPath,
      this.props.relativePath
    );
    const currentStep = children[currentStepIndex];

    return (
      <div className="step-group">
        <ol>
          {React.Children.map(this.props.children, (child, index) =>
            (isStep(child) ? (
              <li
                style={{
                  listStyle: 'none',
                  display: this.props.layout === VIEW_LAYOUT.HORIZONTAL && 'inline-block',
                }}
              >
                <StepsContext.Provider value={{
                  isActive: index === currentStepIndex,
                  isPrevious: index < currentStepIndex,
                }}
                >
                  {child}
                </StepsContext.Provider>
                {this.props.layout === VIEW_LAYOUT.VERTICAL &&
                  index === currentStepIndex &&
                  this.renderStepContent(currentStep)}
              </li>)
              :
              child
            ))
          }
        </ol>
        {this.props.layout === VIEW_LAYOUT.HORIZONTAL &&
          this.renderStepContent(currentStep)}
      </div>);
  }
}
